<template>
	<div class="home">
		<Device>
			<template v-slot:header>
				<FontAwesomeIcon :icon="['fal', 'check']" />
				<h1>{{ $t('sharedTexts.success') }}!</h1>
			</template>

			<p>{{ $t('sharedTexts.compatibleUnit') }}</p>

			<div
				v-if="computedFailedNiceSupport.length"
				class="container__body__missing-features"
			>
				<h6>{{ $t('sharedTexts.missingFeatures.title') }}</h6>
				<ul>
					<li
						v-for="{ name, description } in computedFailedNiceSupport"
						:key="name"
					>
						{{ name }} ({{ $t(description) }})
					</li>
				</ul>

				<p>
					{{ $t('sharedTexts.compatabilityDisclaimer') }}
				</p>
			</div>
			<div class="base-margin--top-large controls controls--right">
				<a
					@click.stop.prevent="this.$router.push('/')"
					class="link"
				>
					{{ $t('sharedTexts.pincodeLink') }}
				</a>
			</div>
		</Device>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { store } from '@libs/store'
import Device from '@/components/Device.vue'

export default defineComponent({
	name: 'HomeView',
	components: {
		Device
	},
	computed: {
		computedFailedNiceSupport() {
			const niceSupport = store.getData('featureSupport.nice') as Record<string, unknown>[]
			return niceSupport.filter((feature: Record<string, unknown>) => !feature.support)
		}
	}
})
</script>
